import { IEnvironment } from './tenant.model';

export const environment: IEnvironment = {
  production: true,

  baseApiUrl: 'https://api-marketplace.avaana.com.au',
  baseCorporateWellbeingUrl: 'https://corporate-wellbeing.avaana.com.au',
  baseLogicHeathApiUrl: 'https://api-logichealth.avaana.com.au',
  baseEMLWorkcoverUrl: 'https://api-eml.avaana.com.au',
  baseTRINITYWorkcoverUrl: 'https://api-trinity.avaana.com.au',
  baseHIIWorkcoverUrl: 'https://api-hii.avaana.com.au',
  baseBlogUrl: 'https://avaana.com.au/blog',

  baseOwnWorkcoverUrl: 'https://api-eml.avaana.com.au',

  appName: 'EML',

  auth0: {
    domain: 'eml-auth.au.auth0.com',
    clientId: 'tjBh0apRg3vZDl4ZDpJduhaAuQc0eUWg'
  },

  sentry: {
    dsn: 'https://b11dc3504c03dc77732fa656fbb032c1@o4507179659624448.ingest.us.sentry.io/4511064746491904',
    tracePropagationTargets: ['https://avaana.com.au', 'https://eml.avaana.com.au']
  },

  clarity: {
    projectId: 'xwftodihsw'
  },

  gtmId: 'GTM-PLLTJ7DN',
  googleMapsApiKey: 'AIzaSyCbfv-NcSLHO0FJo90VA0lfR5kflxcpcso',

  mapbox: {
    accessToken: 'pk.eyJ1Ijoia2FtYWwyNzMwIiwiYSI6ImNscjdld210MjIydnMya3BubmN5MG5hbmsifQ.6hr-rtyierLdnUWUK7C9sw',
    style: 'mapbox://styles/kamal2730/clywpcs48008001p6ar1xgizx'
  },

  intercom: {
    appId: 'tl9uvp8y',
    secretKey: 'Rv9dmgDL53AXEhR6HMj7bBIFt_Hkoek4Z7jJi_2-'
  },

  googleAuth: {
    CLIENT_ID: '',
    API_KEY: ''
  },

  branding: {
    title: 'EML',
    faviconAsset: './assets/images/tenants/eml/eml.ico',
    logoAsset: 'assets/images/tenants/eml/eml-logo.svg',
    logoMobileAsset: 'assets/images/tenants/eml/eml-logo.svg',
    logoWhiteAsset: 'assets/images/tenants/eml/eml-logo-new-white-1.png',
    themeColor: '#ffffff'
  },

  recaptchaKey: '6LdOvGItAAAAAMwKhKCcsr7CSzuofgpQ-Q4ItcTp'
};
